<template>
  <card shadow>
    <template #header>
      <div class="bg-white border-0">
        <div class="row align-items-center">
          <div class="col-md-6 pb-3 pb-md-0 text-start">
            <h5 class="mb-0 float-start">{{ $t("Client Details") }}</h5>
<!--            <span v-if="userRole === 'client'" class="badge float-start bg-danger ms-3" :class="{'bg-gradient-green': $store.state.user.claims?.email_verified, 'bg-danger': !$store.state.user.claims?.email_verified}" >{{ $store.state.user.claims?.email_verified ? 'Email verified' : "Email not verified" }}</span>-->
          </div>
          <div v-if="['system', 'client'].includes(userRole)" class="col-md-6 text-end">
            <div class="btn-group" role="group" aria-label="">
              <base-button type="secondary" size="sm" @click="changeEmail()">{{ $t("Change email") }}</base-button>
              <base-button type="secondary" size="sm" @click="changePhoneNumber()">{{ $t("Change phone number") }}</base-button>

            <router-link class="btn btn-primary btn-sm" :to="userRole === 'system' ? '/clients/'+$route.params.id+'/edit' : '/account/edit'">
              {{ $t("Edit") }}
            </router-link>
            </div>
          </div>
        </div>
      </div>
    </template>

    <form>
<!--      <div class="fw-bolder text-uppercase text-muted mt-4 text-start">Client Details</div>-->
<!--      <hr class="m-0">-->
      <div class="pl-lg-4 text-start">
        <div class="row">
          <div class="col-md-6">
            <display-label
                label="Email"
                :value="clientData.email"
            ></display-label>
          </div>
          <div class="col-md-6">
            <display-label
                label="Phone number"
                :value="clientData.phoneNumber"
            ></display-label>
          </div>
        </div>
      </div>
      <div class="pl-lg-4 text-start">
        <div class="row">
          <div class="col-md-6">
            <display-label
                label="Identity card number"
                :value="clientData.identityCardNumber"
            ></display-label>
          </div>
          <div class="col-md-6">
            <display-label
                label="Contact language"
                :value="$t(clientData.contactLanguage ?? '')"
            ></display-label>
          </div>
        </div>
      </div>
      <div class="pl-lg-4 text-start">
        <div class="row">
          <div class="col-md-6">
            <display-label
                label="Created at:"
                :value="clientData.createdAt"
            ></display-label>
          </div>
        </div>
      </div>
<!--      <div class="fw-bolder text-uppercase text-muted mt-4 text-start">Contact Details</div>-->
<!--      <hr class="m-0">-->

<!--        <client-address :client-data="clientData"></client-address>-->
    </form>
  </card>
  <update-auth v-model:modal-auth-update="updateAuth" v-model:auth-value="updateAuthValue" @on-close="onCloseAuthUpdate"></update-auth>
</template>
<script>
import DisplayLabel from "@/components/DisplayLabel"
import BaseButton from "@/components/BaseButton.vue"
import UpdateAuth from "@/components/UpdateAuth.vue"
export default {
  name: "client-details-card",
  components: {UpdateAuth, BaseButton, DisplayLabel},
  props: {
    clientData: {
      type: Object,
      description: "Client data",
    },
  },
emits: ["fetchData"],
  data() {
    return {
      updateAuth: "",
      updateAuthValue: "",
      positions: [],
      isDisabled: true,
      alertMessage: "",
      loadingProcess: "",
      model: {
        description: "",
        address: {
          street: "",
          countryCode: "",
          city: "",
          lat: 0,
          long: 0 ,
          postalCode: "",
          street2: "",
        },
      }
    }
  },
  computed: {
    userRole(){
      return this.$store.state.user?.claims?.role ?? null
    },
  },
  watch: {
    clientData(newVal) {
      console.log("newVal", newVal)
      this.model = newVal
      this.mapPositions()
    },
  },
  mounted() {
    // var self = this;
    console.log(this.$route.params)
    console.log("clientData card", this.clientData)
    // this.mapCompany();
    this.mapPositions()
  },
  methods: {
    onCloseAuthUpdate(updated){
      if (updated){
        this.$emit("fetchData")
      }
      this.updateAuthValue = ""
      this.updateAuth = ""
    },
    changeEmail(){
      this.updateAuthValue = this.clientData.email
      this.updateAuth = "email"
    },
    changePhoneNumber(){
      this.updateAuthValue = this.clientData.phoneNumber
      this.updateAuth = "phoneNumber"
    },
    async mapPositions(){
      if (!this.clientData.hasOwnProperty("positionIds")){
        return
      }
      let positions = await this.$store.dispatch("fetchAllPositions")

      this.clientData.positionIds.forEach(positionsId => {
        let selected = positions.find(pos => pos.id === positionsId)

        if (selected ?? false) {
          this.positions.push(selected)
        }
      })
    }
  },
}
</script>
<style></style>
